import "../../polyfills/global";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

const TOPIC_MENSAGENS_GLOBAIS = "/topic/mensagens-globais";
const TOPIC_MENSAGENS_GLOBAIS_LEITURAS = "/topic/mensagens-globais-leituras";

function urlHttp() {
  return `${(process.env.REACT_APP_GATEWAY || "").replace(/\/$/, "")}/ws`;
}

function urlNativo() {
  return urlHttp().replace(/^http/, "ws");
}

function interpretarFrame(frame, onEvento, rotulo) {
  if (!frame?.body || !onEvento) return;
  try {
    onEvento(JSON.parse(frame.body));
  } catch (error) {
    console.error(`Falha ao interpretar ${rotulo}`, error);
  }
}

function normalizarOpcoes(onMensagemOuOpcoes, onConectado) {
  if (typeof onMensagemOuOpcoes === "function") {
    return { onMensagem: onMensagemOuOpcoes, onConectado };
  }
  return onMensagemOuOpcoes || {};
}

export function conectarMensagensGlobais(onMensagemOuOpcoes, onConectado) {
  const { onMensagem, onLeitura, onConectado: aoConectar } = normalizarOpcoes(
    onMensagemOuOpcoes,
    onConectado
  );
  const token = window.localStorage.getItem("@oisol/token");
  if (!token) {
    return () => {};
  }

  const headers = { Authorization: `Bearer ${token}` };
  let ativo = null;
  let encerrado = false;
  let sockJsAtivo = false;

  const assinar = (stomp) => {
    if (onMensagem) {
      stomp.subscribe(TOPIC_MENSAGENS_GLOBAIS, (frame) => {
        interpretarFrame(frame, onMensagem, "mensagem global");
      });
    }
    if (onLeitura) {
      stomp.subscribe(TOPIC_MENSAGENS_GLOBAIS_LEITURAS, (frame) => {
        interpretarFrame(frame, onLeitura, "leitura de mensagem global");
      });
    }
    if (aoConectar) {
      aoConectar();
    }
  };

  const criarCliente = (usarSockJs) => {
    const stomp = new Client({
      ...(usarSockJs
        ? { webSocketFactory: () => new SockJS(urlHttp()) }
        : { brokerURL: urlNativo() }),
      connectHeaders: headers,
      reconnectDelay: usarSockJs ? 5000 : 0,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => assinar(stomp),
    });
    return stomp;
  };

  const ativarSockJs = () => {
    if (encerrado || sockJsAtivo) return;
    sockJsAtivo = true;
    if (ativo) {
      ativo.deactivate();
    }
    ativo = criarCliente(true);
    ativo.activate();
  };

  ativo = criarCliente(false);
  ativo.onWebSocketError = ativarSockJs;
  ativo.onStompError = ativarSockJs;
  ativo.activate();

  return () => {
    encerrado = true;
    if (ativo) {
      ativo.deactivate();
    }
  };
}
